import { queryOptions } from "@tanstack/react-query";
import { listAccessoryPhotos } from "@/modules/plus/photos/plus.photos.api";

// One key for the whole collection. Granular invalidation isn't worth it here
// — the collection is small and rarely changes outside our own mutations.
export const photosKeys = {
  all: ["accessory_photos"] as const,
} as const;

export const accessoryPhotosQueryOptions = () =>
  queryOptions({
    queryKey: photosKeys.all,
    queryFn: listAccessoryPhotos,
    // Short stale time — uploads invalidate immediately; this is a safety net
    // if something writes to Firestore from outside our app.
    staleTime: 5 * 60 * 1000,
  });
